export default __webpack_public_path__ + "static/MD_SearchThumb_Cloud_Administration-0ca7d997d73515d2989981cdd8da8e51.webp";